// Generated by purs version 0.15.16
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Ordering from "../Data.Ordering/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as GraphQL_Type from "../GraphQL.Type/index.js";
var append = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var ordRNTY = /* #__PURE__ */ GraphQL_Type.ordRNTY(Data_Ord.ordString);
var nub = /* #__PURE__ */ Data_Array.nub(ordRNTY);
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showInt);
var eq = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ GraphQL_Type.eqRNTY(Data_Eq.eqString));
var compare = /* #__PURE__ */ Data_Ord.compare(ordRNTY);
var compare1 = /* #__PURE__ */ Data_Ord.compare(Data_Ord.ordInt);
var OperationRunning = /* #__PURE__ */ (function () {
    function OperationRunning() {

    };
    OperationRunning.value = new OperationRunning();
    return OperationRunning;
})();
var OperationSucceeded = /* #__PURE__ */ (function () {
    function OperationSucceeded() {

    };
    OperationSucceeded.value = new OperationSucceeded();
    return OperationSucceeded;
})();
var OperationFailed = /* #__PURE__ */ (function () {
    function OperationFailed(value0) {
        this.value0 = value0;
    };
    OperationFailed.create = function (value0) {
        return new OperationFailed(value0);
    };
    return OperationFailed;
})();
var OperationSuperseded = /* #__PURE__ */ (function () {
    function OperationSuperseded() {

    };
    OperationSuperseded.value = new OperationSuperseded();
    return OperationSuperseded;
})();
var LoadRecentForms = /* #__PURE__ */ (function () {
    function LoadRecentForms() {

    };
    LoadRecentForms.value = new LoadRecentForms();
    return LoadRecentForms;
})();
var SaveStep1FormOrder = /* #__PURE__ */ (function () {
    function SaveStep1FormOrder() {

    };
    SaveStep1FormOrder.value = new SaveStep1FormOrder();
    return SaveStep1FormOrder;
})();
var CopyRecentForms = /* #__PURE__ */ (function () {
    function CopyRecentForms(value0) {
        this.value0 = value0;
    };
    CopyRecentForms.create = function (value0) {
        return new CopyRecentForms(value0);
    };
    return CopyRecentForms;
})();
var DeleteRecentForms = /* #__PURE__ */ (function () {
    function DeleteRecentForms(value0) {
        this.value0 = value0;
    };
    DeleteRecentForms.create = function (value0) {
        return new DeleteRecentForms(value0);
    };
    return DeleteRecentForms;
})();
var ExportRecentForms = /* #__PURE__ */ (function () {
    function ExportRecentForms(value0) {
        this.value0 = value0;
    };
    ExportRecentForms.create = function (value0) {
        return new ExportRecentForms(value0);
    };
    return ExportRecentForms;
})();
var RequestRecentFormSignatures = /* #__PURE__ */ (function () {
    function RequestRecentFormSignatures(value0) {
        this.value0 = value0;
    };
    RequestRecentFormSignatures.create = function (value0) {
        return new RequestRecentFormSignatures(value0);
    };
    return RequestRecentFormSignatures;
})();
var UpdateRecentForms = /* #__PURE__ */ (function () {
    function UpdateRecentForms(value0) {
        this.value0 = value0;
    };
    UpdateRecentForms.create = function (value0) {
        return new UpdateRecentForms(value0);
    };
    return UpdateRecentForms;
})();
var LoadStep2Students = /* #__PURE__ */ (function () {
    function LoadStep2Students() {

    };
    LoadStep2Students.value = new LoadStep2Students();
    return LoadStep2Students;
})();
var LoadStep2FormPicker = /* #__PURE__ */ (function () {
    function LoadStep2FormPicker() {

    };
    LoadStep2FormPicker.value = new LoadStep2FormPicker();
    return LoadStep2FormPicker;
})();
var ExportStep2Forms = /* #__PURE__ */ (function () {
    function ExportStep2Forms() {

    };
    ExportStep2Forms.value = new ExportStep2Forms();
    return ExportStep2Forms;
})();
var LoadStep3FormTypes = /* #__PURE__ */ (function () {
    function LoadStep3FormTypes() {

    };
    LoadStep3FormTypes.value = new LoadStep3FormTypes();
    return LoadStep3FormTypes;
})();
var LoadStep3Document = /* #__PURE__ */ (function () {
    function LoadStep3Document(value0) {
        this.value0 = value0;
    };
    LoadStep3Document.create = function (value0) {
        return new LoadStep3Document(value0);
    };
    return LoadStep3Document;
})();
var SaveStep3Document = /* #__PURE__ */ (function () {
    function SaveStep3Document(value0) {
        this.value0 = value0;
    };
    SaveStep3Document.create = function (value0) {
        return new SaveStep3Document(value0);
    };
    return SaveStep3Document;
})();
var AutofillStep3Document = /* #__PURE__ */ (function () {
    function AutofillStep3Document(value0) {
        this.value0 = value0;
    };
    AutofillStep3Document.create = function (value0) {
        return new AutofillStep3Document(value0);
    };
    return AutofillStep3Document;
})();
var ToggleStep3DocumentLock = /* #__PURE__ */ (function () {
    function ToggleStep3DocumentLock(value0) {
        this.value0 = value0;
    };
    ToggleStep3DocumentLock.create = function (value0) {
        return new ToggleStep3DocumentLock(value0);
    };
    return ToggleStep3DocumentLock;
})();
var CreateStep3Comment = /* #__PURE__ */ (function () {
    function CreateStep3Comment(value0) {
        this.value0 = value0;
    };
    CreateStep3Comment.create = function (value0) {
        return new CreateStep3Comment(value0);
    };
    return CreateStep3Comment;
})();
var UpdateStep3Comment = /* #__PURE__ */ (function () {
    function UpdateStep3Comment(value0) {
        this.value0 = value0;
    };
    UpdateStep3Comment.create = function (value0) {
        return new UpdateStep3Comment(value0);
    };
    return UpdateStep3Comment;
})();
var DeleteStep3Comment = /* #__PURE__ */ (function () {
    function DeleteStep3Comment(value0) {
        this.value0 = value0;
    };
    DeleteStep3Comment.create = function (value0) {
        return new DeleteStep3Comment(value0);
    };
    return DeleteStep3Comment;
})();
var CreateStep3Attachment = /* #__PURE__ */ (function () {
    function CreateStep3Attachment(value0) {
        this.value0 = value0;
    };
    CreateStep3Attachment.create = function (value0) {
        return new CreateStep3Attachment(value0);
    };
    return CreateStep3Attachment;
})();
var DeleteStep3Attachment = /* #__PURE__ */ (function () {
    function DeleteStep3Attachment(value0) {
        this.value0 = value0;
    };
    DeleteStep3Attachment.create = function (value0) {
        return new DeleteStep3Attachment(value0);
    };
    return DeleteStep3Attachment;
})();
var SignStep3Document = /* #__PURE__ */ (function () {
    function SignStep3Document(value0) {
        this.value0 = value0;
    };
    SignStep3Document.create = function (value0) {
        return new SignStep3Document(value0);
    };
    return SignStep3Document;
})();
var SignStep3DocumentWithSaved = /* #__PURE__ */ (function () {
    function SignStep3DocumentWithSaved(value0) {
        this.value0 = value0;
    };
    SignStep3DocumentWithSaved.create = function (value0) {
        return new SignStep3DocumentWithSaved(value0);
    };
    return SignStep3DocumentWithSaved;
})();
var RefreshStep3Signatures = /* #__PURE__ */ (function () {
    function RefreshStep3Signatures(value0) {
        this.value0 = value0;
    };
    RefreshStep3Signatures.create = function (value0) {
        return new RefreshStep3Signatures(value0);
    };
    return RefreshStep3Signatures;
})();
var RequestStep3Signatures = /* #__PURE__ */ (function () {
    function RequestStep3Signatures(value0) {
        this.value0 = value0;
    };
    RequestStep3Signatures.create = function (value0) {
        return new RequestStep3Signatures(value0);
    };
    return RequestStep3Signatures;
})();
var BulkToggleDocumentLocks = /* #__PURE__ */ (function () {
    function BulkToggleDocumentLocks(value0) {
        this.value0 = value0;
    };
    BulkToggleDocumentLocks.create = function (value0) {
        return new BulkToggleDocumentLocks(value0);
    };
    return BulkToggleDocumentLocks;
})();
var OperationId = function (x) {
    return x;
};
var Step1GlobalScope = /* #__PURE__ */ (function () {
    function Step1GlobalScope() {

    };
    Step1GlobalScope.value = new Step1GlobalScope();
    return Step1GlobalScope;
})();
var Step1RecentFormsScope = /* #__PURE__ */ (function () {
    function Step1RecentFormsScope() {

    };
    Step1RecentFormsScope.value = new Step1RecentFormsScope();
    return Step1RecentFormsScope;
})();
var Step1FormOrderScope = /* #__PURE__ */ (function () {
    function Step1FormOrderScope() {

    };
    Step1FormOrderScope.value = new Step1FormOrderScope();
    return Step1FormOrderScope;
})();
var Step1DocumentMutationScope = /* #__PURE__ */ (function () {
    function Step1DocumentMutationScope() {

    };
    Step1DocumentMutationScope.value = new Step1DocumentMutationScope();
    return Step1DocumentMutationScope;
})();
var Step1ExportScope = /* #__PURE__ */ (function () {
    function Step1ExportScope() {

    };
    Step1ExportScope.value = new Step1ExportScope();
    return Step1ExportScope;
})();
var Step2GlobalScope = /* #__PURE__ */ (function () {
    function Step2GlobalScope() {

    };
    Step2GlobalScope.value = new Step2GlobalScope();
    return Step2GlobalScope;
})();
var Step2StudentSelectScope = /* #__PURE__ */ (function () {
    function Step2StudentSelectScope() {

    };
    Step2StudentSelectScope.value = new Step2StudentSelectScope();
    return Step2StudentSelectScope;
})();
var Step2FormPickerScope = /* #__PURE__ */ (function () {
    function Step2FormPickerScope() {

    };
    Step2FormPickerScope.value = new Step2FormPickerScope();
    return Step2FormPickerScope;
})();
var Step2ExportScope = /* #__PURE__ */ (function () {
    function Step2ExportScope() {

    };
    Step2ExportScope.value = new Step2ExportScope();
    return Step2ExportScope;
})();
var Step3GlobalScope = /* #__PURE__ */ (function () {
    function Step3GlobalScope() {

    };
    Step3GlobalScope.value = new Step3GlobalScope();
    return Step3GlobalScope;
})();
var Step3DocumentScope = /* #__PURE__ */ (function () {
    function Step3DocumentScope(value0) {
        this.value0 = value0;
    };
    Step3DocumentScope.create = function (value0) {
        return new Step3DocumentScope(value0);
    };
    return Step3DocumentScope;
})();
var TransitionGenerationScope = /* #__PURE__ */ (function () {
    function TransitionGenerationScope(value0) {
        this.value0 = value0;
    };
    TransitionGenerationScope.create = function (value0) {
        return new TransitionGenerationScope(value0);
    };
    return TransitionGenerationScope;
})();
var ordOperationId = Data_Ord.ordInt;
var operationScopes = function (kind) {
    return function (generation) {
        var step3DocumentMutationScopes = function (docId) {
            return [ Step3GlobalScope.value, new Step3DocumentScope(docId) ];
        };
        var baseScopes = (function () {
            if (kind instanceof LoadRecentForms) {
                return [ Step1GlobalScope.value, Step1RecentFormsScope.value ];
            };
            if (kind instanceof SaveStep1FormOrder) {
                return [ Step1GlobalScope.value, Step1FormOrderScope.value ];
            };
            if (kind instanceof CopyRecentForms) {
                return [ Step1GlobalScope.value, Step1DocumentMutationScope.value ];
            };
            if (kind instanceof DeleteRecentForms) {
                return [ Step1GlobalScope.value, Step1DocumentMutationScope.value ];
            };
            if (kind instanceof ExportRecentForms) {
                return [ Step1GlobalScope.value, Step1ExportScope.value ];
            };
            if (kind instanceof RequestRecentFormSignatures) {
                return [ Step1GlobalScope.value, Step1DocumentMutationScope.value ];
            };
            if (kind instanceof UpdateRecentForms) {
                return [ Step1GlobalScope.value, Step1DocumentMutationScope.value ];
            };
            if (kind instanceof LoadStep2Students) {
                return [ Step2GlobalScope.value, Step2StudentSelectScope.value ];
            };
            if (kind instanceof LoadStep2FormPicker) {
                return [ Step2GlobalScope.value, Step2FormPickerScope.value ];
            };
            if (kind instanceof ExportStep2Forms) {
                return [ Step2GlobalScope.value, Step2ExportScope.value ];
            };
            if (kind instanceof LoadStep3FormTypes) {
                return [ Step3GlobalScope.value ];
            };
            if (kind instanceof LoadStep3Document && kind.value0 instanceof Data_Maybe.Nothing) {
                return [ Step3GlobalScope.value ];
            };
            if (kind instanceof LoadStep3Document && kind.value0 instanceof Data_Maybe.Just) {
                return [ Step3GlobalScope.value, new Step3DocumentScope(kind.value0.value0) ];
            };
            if (kind instanceof SaveStep3Document) {
                return [ Step3GlobalScope.value, new Step3DocumentScope(kind.value0) ];
            };
            if (kind instanceof AutofillStep3Document) {
                return [ Step3GlobalScope.value, new Step3DocumentScope(kind.value0) ];
            };
            if (kind instanceof ToggleStep3DocumentLock) {
                return [ Step3GlobalScope.value, new Step3DocumentScope(kind.value0) ];
            };
            if (kind instanceof CreateStep3Comment) {
                return step3DocumentMutationScopes(kind.value0);
            };
            if (kind instanceof UpdateStep3Comment) {
                return step3DocumentMutationScopes(kind.value0);
            };
            if (kind instanceof DeleteStep3Comment) {
                return step3DocumentMutationScopes(kind.value0);
            };
            if (kind instanceof CreateStep3Attachment) {
                return step3DocumentMutationScopes(kind.value0);
            };
            if (kind instanceof DeleteStep3Attachment) {
                return step3DocumentMutationScopes(kind.value0);
            };
            if (kind instanceof SignStep3Document) {
                return step3DocumentMutationScopes(kind.value0);
            };
            if (kind instanceof SignStep3DocumentWithSaved) {
                return step3DocumentMutationScopes(kind.value0);
            };
            if (kind instanceof RefreshStep3Signatures) {
                return step3DocumentMutationScopes(kind.value0);
            };
            if (kind instanceof RequestStep3Signatures) {
                return append([ Step3GlobalScope.value ])(map(Step3DocumentScope.create)(nub(kind.value0)));
            };
            if (kind instanceof BulkToggleDocumentLocks) {
                return [ Step1GlobalScope.value, Step1DocumentMutationScope.value ];
            };
            throw new Error("Failed pattern match at App.Operation.Types (line 119, column 18 - line 145, column 86): " + [ kind.constructor.name ]);
        })();
        return append(baseScopes)(Data_Maybe.maybe([  ])(function (gen) {
            return [ new TransitionGenerationScope(gen) ];
        })(generation));
    };
};
var operationLabel = function (v) {
    if (v instanceof LoadRecentForms) {
        return "Loading recent forms";
    };
    if (v instanceof SaveStep1FormOrder) {
        return "Saving form order";
    };
    if (v instanceof CopyRecentForms) {
        return "Copying " + (show(Data_Array.length(v.value0)) + " forms");
    };
    if (v instanceof DeleteRecentForms) {
        return "Deleting " + (show(Data_Array.length(v.value0)) + " forms");
    };
    if (v instanceof ExportRecentForms) {
        return "Exporting " + (show(Data_Array.length(v.value0)) + " forms");
    };
    if (v instanceof RequestRecentFormSignatures) {
        return "Requesting signatures for " + (show(Data_Array.length(v.value0)) + " forms");
    };
    if (v instanceof UpdateRecentForms) {
        return "Updating " + (show(Data_Array.length(v.value0)) + " forms");
    };
    if (v instanceof LoadStep2Students) {
        return "Loading students";
    };
    if (v instanceof LoadStep2FormPicker) {
        return "Loading form picker";
    };
    if (v instanceof ExportStep2Forms) {
        return "Exporting selected forms";
    };
    if (v instanceof LoadStep3FormTypes) {
        return "Loading form types";
    };
    if (v instanceof LoadStep3Document && v.value0 instanceof Data_Maybe.Nothing) {
        return "Loading form";
    };
    if (v instanceof LoadStep3Document && v.value0 instanceof Data_Maybe.Just) {
        return "Loading form " + GraphQL_Type.innerId(v.value0.value0);
    };
    if (v instanceof SaveStep3Document) {
        return "Saving form " + GraphQL_Type.innerId(v.value0);
    };
    if (v instanceof AutofillStep3Document) {
        return "Autofilling form " + GraphQL_Type.innerId(v.value0);
    };
    if (v instanceof ToggleStep3DocumentLock) {
        return "Updating lock for form " + GraphQL_Type.innerId(v.value0);
    };
    if (v instanceof CreateStep3Comment) {
        return "Creating comment for form " + GraphQL_Type.innerId(v.value0);
    };
    if (v instanceof UpdateStep3Comment) {
        return "Updating comment for form " + GraphQL_Type.innerId(v.value0);
    };
    if (v instanceof DeleteStep3Comment) {
        return "Deleting comment for form " + GraphQL_Type.innerId(v.value0);
    };
    if (v instanceof CreateStep3Attachment) {
        return "Creating attachment for form " + GraphQL_Type.innerId(v.value0);
    };
    if (v instanceof DeleteStep3Attachment) {
        return "Deleting attachment for form " + GraphQL_Type.innerId(v.value0);
    };
    if (v instanceof SignStep3Document) {
        return "Signing form " + GraphQL_Type.innerId(v.value0);
    };
    if (v instanceof SignStep3DocumentWithSaved) {
        return "Signing form " + (GraphQL_Type.innerId(v.value0) + " with saved signature");
    };
    if (v instanceof RefreshStep3Signatures) {
        return "Refreshing signatures for form " + GraphQL_Type.innerId(v.value0);
    };
    if (v instanceof RequestStep3Signatures) {
        return "Requesting signatures for " + (show(Data_Array.length(v.value0)) + " forms");
    };
    if (v instanceof BulkToggleDocumentLocks) {
        return "Updating " + (show(Data_Array.length(v.value0)) + " forms");
    };
    throw new Error("Failed pattern match at App.Operation.Types (line 87, column 18 - line 113, column 90): " + [ v.constructor.name ]);
};
var eqOperationScope = {
    eq: function (x) {
        return function (y) {
            if (x instanceof Step1GlobalScope && y instanceof Step1GlobalScope) {
                return true;
            };
            if (x instanceof Step1RecentFormsScope && y instanceof Step1RecentFormsScope) {
                return true;
            };
            if (x instanceof Step1FormOrderScope && y instanceof Step1FormOrderScope) {
                return true;
            };
            if (x instanceof Step1DocumentMutationScope && y instanceof Step1DocumentMutationScope) {
                return true;
            };
            if (x instanceof Step1ExportScope && y instanceof Step1ExportScope) {
                return true;
            };
            if (x instanceof Step2GlobalScope && y instanceof Step2GlobalScope) {
                return true;
            };
            if (x instanceof Step2StudentSelectScope && y instanceof Step2StudentSelectScope) {
                return true;
            };
            if (x instanceof Step2FormPickerScope && y instanceof Step2FormPickerScope) {
                return true;
            };
            if (x instanceof Step2ExportScope && y instanceof Step2ExportScope) {
                return true;
            };
            if (x instanceof Step3GlobalScope && y instanceof Step3GlobalScope) {
                return true;
            };
            if (x instanceof Step3DocumentScope && y instanceof Step3DocumentScope) {
                return eq(x.value0)(y.value0);
            };
            if (x instanceof TransitionGenerationScope && y instanceof TransitionGenerationScope) {
                return x.value0 === y.value0;
            };
            return false;
        };
    }
};
var ordOperationScope = {
    compare: function (x) {
        return function (y) {
            if (x instanceof Step1GlobalScope && y instanceof Step1GlobalScope) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof Step1GlobalScope) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Step1GlobalScope) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof Step1RecentFormsScope && y instanceof Step1RecentFormsScope) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof Step1RecentFormsScope) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Step1RecentFormsScope) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof Step1FormOrderScope && y instanceof Step1FormOrderScope) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof Step1FormOrderScope) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Step1FormOrderScope) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof Step1DocumentMutationScope && y instanceof Step1DocumentMutationScope) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof Step1DocumentMutationScope) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Step1DocumentMutationScope) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof Step1ExportScope && y instanceof Step1ExportScope) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof Step1ExportScope) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Step1ExportScope) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof Step2GlobalScope && y instanceof Step2GlobalScope) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof Step2GlobalScope) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Step2GlobalScope) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof Step2StudentSelectScope && y instanceof Step2StudentSelectScope) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof Step2StudentSelectScope) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Step2StudentSelectScope) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof Step2FormPickerScope && y instanceof Step2FormPickerScope) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof Step2FormPickerScope) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Step2FormPickerScope) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof Step2ExportScope && y instanceof Step2ExportScope) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof Step2ExportScope) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Step2ExportScope) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof Step3GlobalScope && y instanceof Step3GlobalScope) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof Step3GlobalScope) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Step3GlobalScope) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof Step3DocumentScope && y instanceof Step3DocumentScope) {
                return compare(x.value0)(y.value0);
            };
            if (x instanceof Step3DocumentScope) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Step3DocumentScope) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof TransitionGenerationScope && y instanceof TransitionGenerationScope) {
                return compare1(x.value0)(y.value0);
            };
            throw new Error("Failed pattern match at App.Operation.Types (line 0, column 0 - line 0, column 0): " + [ x.constructor.name, y.constructor.name ]);
        };
    },
    Eq0: function () {
        return eqOperationScope;
    }
};
var eqOperationId = Data_Eq.eqInt;
export {
    OperationId,
    LoadRecentForms,
    SaveStep1FormOrder,
    CopyRecentForms,
    DeleteRecentForms,
    ExportRecentForms,
    RequestRecentFormSignatures,
    UpdateRecentForms,
    LoadStep2Students,
    LoadStep2FormPicker,
    ExportStep2Forms,
    LoadStep3FormTypes,
    LoadStep3Document,
    SaveStep3Document,
    AutofillStep3Document,
    ToggleStep3DocumentLock,
    CreateStep3Comment,
    UpdateStep3Comment,
    DeleteStep3Comment,
    CreateStep3Attachment,
    DeleteStep3Attachment,
    SignStep3Document,
    SignStep3DocumentWithSaved,
    RefreshStep3Signatures,
    RequestStep3Signatures,
    BulkToggleDocumentLocks,
    Step1GlobalScope,
    Step1RecentFormsScope,
    Step1FormOrderScope,
    Step1DocumentMutationScope,
    Step1ExportScope,
    Step2GlobalScope,
    Step2StudentSelectScope,
    Step2FormPickerScope,
    Step2ExportScope,
    Step3GlobalScope,
    Step3DocumentScope,
    TransitionGenerationScope,
    OperationRunning,
    OperationSucceeded,
    OperationFailed,
    OperationSuperseded,
    operationLabel,
    operationScopes,
    eqOperationId,
    ordOperationId,
    eqOperationScope,
    ordOperationScope
};
//# sourceMappingURL=index.js.map
